import axiosFetch from './config';

export const getBanks = async () => {
  return axiosFetch({
    method: 'GET',
    url: `/banks/accounts`,
    headers: {
      Authorization: await localStorage.getItem('token')
    },
  })
}

export const getBanksByCountryId = async (countryId) => {
  return axiosFetch({
    method: 'GET',
    url: `/banks/accounts?countryId=${countryId}`,
    headers: {
      Authorization: await localStorage.getItem('token')
    },
  })
}

export const getBankInfo = async (countryId) => {
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method: "GET",
    url: `/banks?countryId=${countryId}`,
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
}

export const postBanks = async (data) => {
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method: 'POST',
    data,
    url: '/banks/accounts',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const deleteBankbyId = async (id) => {
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method: 'DELETE',
    url: `/banks/accounts/${id}`,
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })
}
